(function () {
  'use strict';

  angular
    .module('service.account', ['factories.serviceHelper'])
    .factory('AccountService', AccountService);

  AccountService.$inject = ['$http', 'ServiceHelper'];

  function AccountService($http, ServiceHelper) {
    var url = {
      base: 'https://:host/:ipad/gaviota-api/auth/currentaccount'
    };

    var keys = ['ipad'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key]
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb)(response);
      });
    }

    function getCurrentAccount(resultCb, errorCb) {
      return ServiceHelper.checkCanCallServiceWithoutBeingLoggedIn(function () {
        return respond($http.get(createUrl(url.base, ServiceHelper.defaultUrlParams())),
          resultCb, errorCb);
      });
    }

    return {
      getCurrentAccount: getCurrentAccount
    };
  }

})();
